module.exports = __webpack_public_path__ + "img/84.d575c630.jpg";